import React from "react";
import { Box, IconButton, StarIcon } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const RoundedBorderedIconButton = () => {
  return (
    <Box p={3} sx={{ width: "80%", margin: "0 auto" }}>
      <PreviewAndEditor
        background
        title={"Rounded Bordered IconButtons"}
        height={"150px"}
        language={"js"}
        value={
          '      <IconButton variant={"roundedBorder"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton variant={"roundedBorder"} color={"primary"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton variant={"roundedBorder"} color={"secondary"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton variant={"roundedBorder"} color={"error"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton variant={"roundedBorder"} color={"warning"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton variant={"roundedBorder"} color={"info"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton variant={"roundedBorder"} color={"success"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton variant={"roundedBorder"} color={"inherit"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton variant={"roundedBorder"} color={"inheritWhite"}>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>\n" +
          '        <IconButton variant={"roundedBorder"} disabled>\n' +
          "          <StarIcon />\n" +
          "        </IconButton>"
        }
      >
        <IconButton variant={"roundedBorder"}>
          <StarIcon />
        </IconButton>
        <IconButton variant={"roundedBorder"} color={"primary"}>
          <StarIcon />
        </IconButton>
        <IconButton variant={"roundedBorder"} color={"secondary"}>
          <StarIcon />
        </IconButton>
        <IconButton variant={"roundedBorder"} color={"error"}>
          <StarIcon />
        </IconButton>
        <IconButton variant={"roundedBorder"} color={"warning"}>
          <StarIcon />
        </IconButton>
        <IconButton variant={"roundedBorder"} color={"info"}>
          <StarIcon />
        </IconButton>
        <IconButton variant={"roundedBorder"} color={"success"}>
          <StarIcon />
        </IconButton>
        <IconButton variant={"roundedBorder"} color={"inherit"}>
          <StarIcon />
        </IconButton>
        <IconButton variant={"roundedBorder"} color={"inheritWhite"}>
          <StarIcon />
        </IconButton>
        <IconButton variant={"roundedBorder"} disabled>
          <StarIcon />
        </IconButton>
      </PreviewAndEditor>
    </Box>
  );
};

export default RoundedBorderedIconButton;
